import type { ReactNode } from 'react';

import { ReportHeaderTooltip } from './ReportHeaderTooltip';

/**
 * Wraps a column header value in a Tooltip for truncated text display.
 */
export const renderHeaderTooltip = (value: string): ReactNode => {
  return <ReportHeaderTooltip value={value} />;
};

/**
 * Returns a display prefix based on entity context.
 */
export const getTitle = (school?: boolean, player?: boolean): string => {
  if (school) return 'School  ';
  if (player) return 'Player ';
  return 'Team ';
};

/**
 * Report type labels shown in the team-level navigation dropdown.
 */
export const teamLabels: Record<string, string> = {
  summary: 'Summary',
  'sticker-count': 'Sticker Count (Activity)',
  gym: 'Gyms (Fact Fluency)',
  'just-the-facts': 'Just The Facts',
  'know-and-show': 'Know And Show (Word Problem Fluency)',
  'skill-set-games': 'Skill Sets (Procedural Fluency)',
  'computational-thinking': 'Computational Thinking',
  'very-important-facts': 'Very Important Facts',
  early: 'Early',
  'measurement-world': 'Measurement World',
  'goals-index': 'Goals Index',
  'algebra-goals-metric': 'Algebra Goals Metric',
  bonuses: 'Bonus Games',
  'fluency-games': 'Fluency Games',
  'what-do-you-know': 'What Do You Know',
};

/**
 * Report type labels shown in the school-level navigation dropdown.
 */
export const schoolLabels: Record<string, string> = {
  summary: 'Summary',
  'goals-index': 'Goals Index',
  'algebra-goals-metric': 'Algebra Goals Metric',
  'sticker-count': 'Activity-Sticker Count',
  gym: 'Fact Fluency-Gyms',
  'skill-set-games': 'Procedural Fluency - Skill Sets',
  'know-and-show': 'Know And Show (Word Problem Fluency)',
  'just-the-facts': 'Just The Facts',
  'very-important-facts': 'Very Important Facts',
};
